module.exports = __webpack_public_path__ + "static/media/body_parts.041703f9.png";